import React, { Component } from 'react';
import { connect } from 'react-redux';

class GraduationPrincipale extends Component {
    render() {
        const { unites } = this.props;
        const intervalle = 2800 / unites;
        return (
            <g>
                {Array(unites + 1)
                    .fill('')
                    .map((v, u) => (
                        <line
                            key={u}
                            x1={100 + u * intervalle}
                            y1="150"
                            x2={100 + u * intervalle}
                            y2="250"
                            strokeWidth="4"
                            strokeLinecap="round"
                            stroke="#ff0000"
                        />
                    ))}
            </g>
        );
    }
}

const mapStateToProps = ({ unites }) => ({ unites });

export default connect(mapStateToProps)(GraduationPrincipale);
